import {Anchor} from "../../config/constants"

export const getAnchorDirection = (isOpeningFromBottom): Anchor => {
    return isOpeningFromBottom ? "bottom" : "right"
}
